import axios from '@/axios';

const RESOURCE_NAME = '/ecosystem/needs';

export default {
    getInfo(id) {
        return axios.get(`${RESOURCE_NAME}/get-info?id=${id}`);
    },

    getSuggestedStartups(id, filters) {
        return axios.post(`${RESOURCE_NAME}/get-suggested-startups?id=${id}`, filters);
    },

    getStartups(id, filters) {
        return axios.post(`${RESOURCE_NAME}/get-startups?id=${id}`, filters);
    },

    getStartupsListToAdd(id, search) {
        return axios.get(`${RESOURCE_NAME}/get-startups-list-to-add`, {
            params: {id, search}
        });
    },

    addStartup(id, form) {
        return axios.post(`${RESOURCE_NAME}/add-startup?id=${id}`, form);
    },
}
